import { Moment } from 'moment';
import { GetMomentOfDate } from 'utils/dates/moment';

export const getExtensionDuration = (startDateMoment: Moment, newValue) => {
  const newEndDateMoment = GetMomentOfDate(newValue);
  const diff = newEndDateMoment.diff(startDateMoment, 'd');
  return Math.floor(diff % 7 < 2 ? diff / 7 : diff / 7 + 1);
};
